export const TRENDING_PALETTE_NAME = 'Trending 2024';
export const DEFAULT_PALETTE_NAME = TRENDING_PALETTE_NAME;
